module.exports = __webpack_public_path__ + "static/media/20201219_114153_229_IMG_3365.ce298a9f.jpg";